import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Navigation = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const toggleNav = () => {
    setNavbarOpen(!navbarOpen);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <div className="bg-whiteBackground flex flex-col space-y-3 w-full">
      <div className="flex flex-row justify-between py-2 sm:py-4 bg-whiteBackground">
        <div className="h-10 w-10 rounded-[50%] bg-lightBlack text-whiteBackground flex flex-row items-center justify-center cursor-pointer font-lora text-xl">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ rotate: 360, scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20,
            }}
          >
            CS
          </motion.div>
        </div>
        <button
          className="text-3xl sm:text-2xl font-bold text-darkBlack pr-2 md:pr-2 lg:pr-16"
          onClick={() => setNavbarOpen(!navbarOpen)}
        >
          {navbarOpen ? "✕" : "☰"}
        </button>
      </div>
      {navbarOpen && (
        <div className="text-md text-darkBlack font-semibold sm:text-lg flex flex-col space-y-4 items-start justify-start">
          <a
            className="w-full cursor-pointer flex flex-row items-center gap-5 pb-2 shadow-sm active:shadow-lg"
            onClick={() => toggleNav()}
            href="/"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="M6 19h3v-6h6v6h3v-9l-6-4.5L6 10Zm-2 2V9l8-6 8 6v12h-7v-6h-2v6Zm8-8.75Z" />
            </svg>
            <Link to="/">Home</Link>
          </a>
          <a
            href="/works"
            className="w-full cursor-pointer flex flex-row items-center gap-5 pb-2 shadow-sm active:shadow-lg"
            onClick={() => toggleNav()}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="m18.9 21-5.475-5.475 2.1-2.1L21 18.9ZM5.1 21 3 18.9 9.9 12l-1.7-1.7-.7.7-1.275-1.275v2.05l-.7.7L2.5 9.45l.7-.7h2.05L4 7.5l3.55-3.55q.5-.5 1.075-.725Q9.2 3 9.8 3q.6 0 1.175.225.575.225 1.075.725l-2.3 2.3L11 7.5l-.7.7L12 9.9l2.25-2.25q-.1-.275-.162-.575-.063-.3-.063-.6 0-1.475 1.013-2.488 1.012-1.012 2.487-1.012.375 0 .713.075.337.075.687.225L16.45 5.75l1.8 1.8 2.475-2.475q.175.35.238.687.062.338.062.713 0 1.475-1.012 2.487Q19 9.975 17.525 9.975q-.3 0-.6-.05t-.575-.175Z" />
            </svg>
            <Link to="/works">Works</Link>
          </a>
          <a
            href="https://mega.nz/file/8nRmVCoD#Buhc51Sq1TCz13Z8lGw4ioLIWcZTBV2zexY9D1WX0ec"
            target="_blank"
            rel="noreferrer"
            className="w-full cursor-pointer flex flex-row items-center gap-5 pb-2 shadow-sm active:shadow-lg"
            onClick={() => toggleNav()}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="M6 22q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h8.175q.4 0 .763.15.362.15.637.425l3.85 3.85q.275.275.425.637.15.363.15.763V20q0 .825-.587 1.413Q18.825 22 18 22Zm0-2h12V8h-3q-.425 0-.712-.287Q14 7.425 14 7V4H6v16ZM6 4v4-4 16V4Zm6 15q1.675 0 2.838-1.175Q16 16.65 16 15v-3q0-.425-.287-.713Q15.425 11 15 11t-.712.287Q14 11.575 14 12v3q0 .825-.575 1.413Q12.85 17 12 17q-.825 0-1.412-.587Q10 15.825 10 15V9.5q0-.225.15-.363Q10.3 9 10.5 9q.225 0 .363.137.137.138.137.363V14q0 .425.288.712.287.288.712.288t.713-.288Q13 14.425 13 14V9.5q0-1.05-.725-1.775Q11.55 7 10.5 7q-1.05 0-1.775.725Q8 8.45 8 9.5V15q0 1.65 1.175 2.825Q10.35 19 12 19Z" />
            </svg>
            Resume
          </a>
          <a
            href="/journal"
            className="w-full cursor-pointer flex flex-row items-center gap-5 pb-2 shadow-sm active:shadow-lg"
            onClick={() => toggleNav()}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="M8 20q-.825 0-1.412-.587Q6 18.825 6 18v-3h3v-2.25q-.875-.05-1.662-.388-.788-.337-1.438-1.012v-1.1H4.75L1.5 7q.9-1.15 2.225-1.625Q5.05 4.9 6.4 4.9q.675 0 1.313.1.637.1 1.287.375V4h12v13q0 1.25-.875 2.125T18 20Zm3-5h6v2q0 .425.288.712.287.288.712.288t.712-.288Q19 17.425 19 17V6h-8v.6l6 6V14h-1.4l-2.85-2.85-.2.2q-.35.35-.738.625-.387.275-.812.425ZM5.6 8.25h2.3v2.15q.3.2.625.275.325.075.675.075.575 0 1.038-.175.462-.175.912-.625l.2-.2-1.4-1.4q-.725-.725-1.625-1.088Q7.425 6.9 6.4 6.9q-.5 0-.95.075-.45.075-.9.225ZM15 17H8v1h7.15q-.075-.225-.112-.475Q15 17.275 15 17Zm-7 1v-1 1Z" />
            </svg>
            <Link to="/journal">Notes</Link>
          </a>
        </div>
      )}
    </div>
  );
};
